import { Directive, Input, HostListener } from '@angular/core';


/**------------------------------------------------------
 * Download file
 * -------------
 * Download a file like a PDF from the website locally
 * on the pc.
 *
 * Example:
 * --------
 * 	 <button [ngDownloadFile]="myFileData" fileName="myPdfFile.pdf"> ... </button>
 */
@Directive({
    selector: '[ngDownloadFile]',
    standalone: false
})
export class NgFileDownloadDirective {

	@Input('ngDownloadFile') data !: ArrayBuffer | string | Blob;
	@Input() fileName			  !: string;

	@HostListener('click', ['$event'])
	public onClick(): void {

		//0 - check the directive call
		if (!this.fileName) throw new Error(`NgFileDownloadDirective => onClick => FATAL ERROR: file name was not provided`);

		//1 - create the link
		const link: HTMLAnchorElement = document.createElement('a');
		link.href	  = window.URL.createObjectURL(this.data as Blob);
		link.download = this.fileName;

		//2 - trigger the download
		link.click();
		link.remove();
		window.URL.revokeObjectURL(link.href);
	}
}
